export default "__VITE_ASSET__BKc8sf6V__"